import { useCallback } from "react";

import type { TestEmailInput } from "@/lib/gql/__generated__/graphql";

import { useCustomMutation } from "@/hooks/use-graphql-client";

import { notifyUserEventInfo } from "@/components/features/side-effect/notify-user-event-info";
import { useLoadingScreen } from "@/components/features/side-effect/show-loading-screen-to-user/_hooks/use-loading-screen";

import { SEND_SAMPLE_EMAIL_REQUEST_RESERVATION_CONFIRMED_MUTATION } from "./mutation";

/**
 * @todo APIが未実装のため、未完成
 */
export const useSendTestEmailRequestReservationConfirmed = () => {
	const { showLoadingScreenCallback, hideLoadingScreenCallback } = useLoadingScreen();

	const { mutationFunc } = useCustomMutation(SEND_SAMPLE_EMAIL_REQUEST_RESERVATION_CONFIRMED_MUTATION);

	const onSendTestEmailRequestReservationConfirmed = useCallback(
		async (input: TestEmailInput) => {
			showLoadingScreenCallback();

			const { errors } = await mutationFunc({
				variables: {
					input,
				},
			}).finally(() => hideLoadingScreenCallback());

			if (!errors) {
				notifyUserEventInfo({
					title: "メールを送信しました",
				});
			}
		},
		[hideLoadingScreenCallback, mutationFunc, showLoadingScreenCallback],
	);

	return {
		onSendTestEmailRequestReservationConfirmed,
	};
};
